import {
  FetchPopularPositionsProps,
  analyticsApi,
} from "@src/service/analytics";
import { AnalyticsSalesModel } from "../domain/AnalyticsSalesModel";
import { AnalyticsSalesModelMapper } from "../domain/SalesModelMapper";

export const fetchAnalyticsSalesRepo = {
  async execute(
    props: FetchPopularPositionsProps
  ): Promise<AnalyticsSalesModel> {
    try {
      const response = await analyticsApi.fetchSales(props);

      if (response === null || response === undefined) {
        return Promise.reject("No Data");
      }

      return AnalyticsSalesModelMapper.execute(
        response,
        props.startDate,
        props.endDate
      );
    } catch (e) {
      return Promise.reject(e);
    }
  },
};
